// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import moment from 'moment';
import Vuelidate from 'vuelidate';
// eslint-disable-next-line
import momentTimezone from 'moment-timezone';
import App from './App';
import router from './router/index';
import store from './store/index';
import { createI18n } from './i18n';
import '@/filters/translateFilter';
import '@/filters/currencyFilter';
import '@/filters/timeFilter';
import './filters/momentFilter';
import language from '@/util/language'
import accounting from 'accounting-js';
import utils from '@/util/utils';
import VehicleCatalogSelection from '@com.cardess/legacy-vehicle-catalog-selection';
import RegionSelection from '@com.cardess/legacy-region-selection';
import SharedVueComponents from '@com.cardess/legacy-shared-vue-components';
import vSelect from 'vue-select';

const i18n = createI18n();

moment.tz.setDefault(language.getCountryConfigTimezone());
moment.locale(language.getCurrentLanguage());

Vue.config.productionTip = false;
Vue.i18n = i18n;
Vue.prototype.$SMP_CONFIG = SMP_CONFIG;
Vue.prototype.i18n = i18n;
Vue.use(Vuelidate);
Vue.use(VehicleCatalogSelection, { store, i18n });
Vue.use(RegionSelection, { i18n });
Vue.use(SharedVueComponents);
Vue.component('v-select', vSelect);

accounting.settings = {
  currency: {
    symbol: utils.getCurrencySymbol(),
    format: {
      pos: utils.getCurrencySymbolPosition(), // controls output: %s = symbol, %v = value/number
      zero: utils.getCurrencySymbolPosition() // has to be here, otherwise 0 can't be formatted and it throws an err, https://github.com/openexchangerates/accounting.js/issues/139
    },
    decimal: utils.getDecimalSeparator(), // decimal point separator
    thousand: utils.getThousandSeparator(), // thousands separator
    precision: 2 // decimal places
  },
  number: {
    precision: 2,
    thousand: '',
    decimal: ','
  }
};

Vue.prototype.$accounting = accounting;

/* eslint-disable no-new */
new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#fg-service-consumer');
